import { useMutation } from "react-query";
import axios from "../axios";

type AktifTrialResponse = {
    code: number;
    message: string;
};

const aktifTrial = async (ukmId: string | number) => {
    const formData = new FormData();
    formData.append("ukmId", String(ukmId));
    const response = await axios.post<AktifTrialResponse>(
        "/api/aktiftrial",
        formData,
        { headers: { "Content-Type": "multipart/form-data" } },
    );
    return response.data;
};

export default function useAktifTrial() {
    return useMutation((ukmId: string | number) => aktifTrial(ukmId));
}
